// Each resource is prefixed because `BOTS_LIST` means different things across slices.
const actions = {
  SET_STATE: 'customBots/SET_STATE',

  // Custom Bots tab — chat-api /bots
  CUSTOM_BOTS_LIST: 'customBots/CUSTOM_BOTS_LIST',
  GET_CUSTOM_BOT: 'customBots/GET_CUSTOM_BOT',
  ADD_CUSTOM_BOT: 'customBots/ADD_CUSTOM_BOT',
  UPDATE_CUSTOM_BOT: 'customBots/UPDATE_CUSTOM_BOT',
  DELETE_CUSTOM_BOT: 'customBots/DELETE_CUSTOM_BOT',
  CHANGE_CUSTOM_BOT_STATUS: 'customBots/CHANGE_CUSTOM_BOT_STATUS',

  // AI Bots (Legacy) tab — ai-api /ai/bots
  AI_BOTS_LIST: 'customBots/AI_BOTS_LIST',
  GET_AI_BOT: 'customBots/GET_AI_BOT',
  ADD_AI_BOT: 'customBots/ADD_AI_BOT',
  UPDATE_AI_BOT: 'customBots/UPDATE_AI_BOT',
  DELETE_AI_BOT: 'customBots/DELETE_AI_BOT',
  CHANGE_AI_BOT_STATUS: 'customBots/CHANGE_AI_BOT_STATUS',

  // AI Instructions (Legacy) tab — ai-api /ai/personalities
  AI_INSTRUCTIONS_LIST: 'customBots/AI_INSTRUCTIONS_LIST',
  GET_AI_INSTRUCTION: 'customBots/GET_AI_INSTRUCTION',
  ADD_AI_INSTRUCTION: 'customBots/ADD_AI_INSTRUCTION',
  UPDATE_AI_INSTRUCTION: 'customBots/UPDATE_AI_INSTRUCTION',
  DELETE_AI_INSTRUCTION: 'customBots/DELETE_AI_INSTRUCTION',

  // Dropdown options for the AI Bot form. Separate from the tab's list so the
  // form's unpaginated fetch can't overwrite the table's page.
  AI_INSTRUCTION_OPTIONS: 'customBots/AI_INSTRUCTION_OPTIONS',
} as const

export default actions
